import ResponsiveTable from "../../table"
import Content from "./content"
import { PropTypes } from 'prop-types';

const ContactUsPopUp = ({ contactUs }) => {
    const contacts = [
        `Innovation & Research Management Center (iRMC)
        Level 3, Administration Building
        Universiti Tenaga Nasional (UNITEN)
        Putrajaya Campus, Jalan IKRAM-UNITEN
        43000 Kajang, Selangor, MALAYSIA.
        `, `
        T +603-8921 2020
        F +603-8921 2113
        Facebook : irmcuniten`
    ]
    const table = {
        headers: [
            "Name",
            "Position",
            "Ext. No",
            "Email"
        ],
        contents: [
            ["Assoc. Prof. Dr. Normy Norfiza Binti Abdul Razak", "Director", "T: +603-8921 2020 ext 7321", "Normy@uniten.edu.my"],
            ["Assoc. Prof. Dr. Normy Norfiza Binti Abdul Razak", "Director", "T: +603-8921 2020 ext 7321", "Normy@uniten.edu.my"],
            ["Assoc. Prof. Dr. Normy Norfiza Binti Abdul Razak", "Director", "T: +603-8921 2020 ext 7321", "Normy@uniten.edu.my"],
            ["Assoc. Prof. Dr. Normy Norfiza Binti Abdul Razak", "Director", "T: +603-8921 2020 ext 7321", "Normy@uniten.edu.my"],
            ["Assoc. Prof. Dr. Normy Norfiza Binti Abdul Razak", "Director", "T: +603-8921 2020 ext 7321", "Normy@uniten.edu.my"],


        ]
    }
    return (
        <div className="flex flex-col gap-5 w-full   p-8 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
            {/* <h1 className=" text-2xl  font-bold">Contact Us</h1> */}
            <Content richTextContent={contactUs} />
            {/* {
                contacts.map((contact, index) => {
                    return (
                        <div className="grid font-bold" key={index}>
                            {
                                contact.split('\n').filter(line => line.trim() !== '').map((line, index) => {
                                    return (
                                        <p key={index} className="w-auto  text-justify  text-base  leading-normal">{line}</p>
                                    )
                                }
                                )
                            }

                        </div>
                    )
                }
                )
            }
              <h1 className=" text-2xl  font-bold">Staff Directory</h1>
              <ResponsiveTable {...table} headerBg="bg-[#2C2E82] text-white border-[#919191]"/> */}
        </div>
    )
}
ContactUsPopUp.propTypes = {
    contactUs: PropTypes.any
}
export default ContactUsPopUp